import { useRouter } from "@faire/retailer-visitor-shared/app/_lib/routing/useRouter";
import { usePathname, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export const useUpdateQueryParam = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  return useCallback(
    (key: string, value: string | undefined) => {
      const queryParams = new URLSearchParams(searchParams);
      if (value) {
        queryParams.set(key, value);
      } else {
        queryParams.delete(key);
      }
      const queryParamsString = queryParams.toString();
      if (queryParamsString) {
        router.push(pathname + "?" + queryParamsString);
      } else {
        router.push(pathname);
      }
    },
    [pathname, router, searchParams]
  );
};
